import React, { ReactElement } from 'react';
import { useLocalization } from '../../context/Localization/localization';
import { formatAsCurrency } from '../../helpers/Number';
import { GMInfoGrid, GMInfoGridColumn, GMInfoGridRow } from '../InfoGrid';
import { IServiceItemProps } from './ServiceItem';
import css from './ServiceItemList.module.scss';

interface IServiceItemList {
    children: ReactElement<IServiceItemProps>[];
    hideTotal?: boolean;
}

export const ServiceItemList: React.FC<IServiceItemList> = (props) => {
    const Localization = useLocalization();
    const totalPrice = props.children.map((child) => child.props.minEstCost)
        .reduce((current, total) => (current ?? NaN) + (total ?? NaN), 0);

    return (
        <div className={css.serviceItemList}>
            <GMInfoGrid>
                {React.Children.map(props.children, (child: React.ReactElement, index) => (
                    <GMInfoGridRow key={`service-item-${child.key ?? index}`}>
                        <GMInfoGridColumn>{child}</GMInfoGridColumn>
                    </GMInfoGridRow>
                ))}
            </GMInfoGrid>
            <h3 className={css.minimumCost}>
                {props.hideTotal
                    ? null
                    : totalPrice !== undefined && !isNaN(totalPrice)
                        ? totalPrice === 0
                            ? ''
                            : Localization.formatString(Localization.MinimumEstCost, formatAsCurrency(totalPrice))
                        : Localization.AskUsAboutPricing}
            </h3>
        </div>
    );
};
